<manage-wrapper
  *ngIf="!!sessionInfo && { synopsis: synopsis[sessionInfo.id] } as vars"
  [canEditMain]="readState === readStates.Program && !event?.is_readonly"
  [topToggleText]="'SHOW IN PUBLISH'"
  [topToggled]="!sessionInfo.fullSession?.hideInPublish"
  [entityTitle]="sessionInfo.fullSession?.title || ''"
  [tabGroups]="tabGroups"
  [selectedTab]="selectedTab"
  [readOnly]="readState !== readStates.Program || event?.is_readonly || false"
  [labels]="sessionInfo.fullSession?.labels || []"
  [labelMap]="labelMap"
  [labelList]="labels"
  [deleteTitle]="'Delete this session'"
  [labelUpdateFunction]="labelUpdateFunction.bind(this)"
  titlePlaceholder="Session title..."
  backgroundColor="#A6DBFF"
  dialogTitle="Manage Session"
  (onToggle)="toggleShowInPublish(sessionInfo)"
  (onDone)="exit()"
  (onDuplicate)="duplicate()"
  (onChangeTab)="changeTab($event)"
  (onDelete)="delete()"
  (saveTitle)="updateSessionTitle($event)"
>
  <!-- manage-header-item is a ng-content selector for the manage-wrapper -->
  <session-status manage-header-item style="display: flex; align-items: center;" [dotOnly]="false" [programId]="sessionInfo.programId" [sessionId]="sessionInfo.id"></session-status>
  <div class="dateTime">
    <icon class="flag" [ngClass]="{flagon:sessionInfo.flag}" (click)="toggleFlag()" [icon]="sessionInfo.flag ? 'flagon' : 'flagoff'"></icon>
    {{ sessionInfo.fullSession?.duration }} minutes&nbsp;&nbsp;|&nbsp;&nbsp;{{ sessionInfo.start }} - {{sessionInfo.end}}
    <ng-container *ngIf="!sessionInfo.day">&nbsp;&nbsp;|&nbsp;&nbsp;{{ sessionInfo.date | date:'EEE d MMMM y' }}</ng-container>
    &nbsp;&nbsp;|&nbsp;&nbsp;
    <span *ngIf="sessionInfo.programTitle">{{ sessionInfo.programTitle }}</span>
    <em *ngIf="!sessionInfo.programTitle">Untitled program</em>
  </div>

  <ng-container *ngIf="!selectedTab || selectedTab?.id === tabs.info">
    <ng-container *ngIf="readState === readStates.Program && !event?.is_readonly">
      <ng-container *ngIf="vars.synopsis?.status === 'Active'">
        <tip-text class="top" [type]="'warn'" [head]="'Attention:'" [body]="'This session has an active webform to receive session information.'"></tip-text>
      </ng-container>
      <ng-container *ngIf="vars.synopsis?.status !== 'Active'">
        <tip-text class="top" [type]="'tip'" [head]="'Tip:'" [body]="'You can receive session information by turning on <strong>Receive session information</strong> below.'"></tip-text>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="readState === readStates.Program && !event?.is_readonly">
      <title-toggle-wrapper
       style="display: block; margin-bottom: 20px;"
       [title]="'Receive session information'"
       [toggleOn]="showSessionSynopsisSelection"
       [toggleStates]="['OFF','ON']"
       [hideBottom]="false"
       (toggle)="toggleShowSessionSynopsisSelection($event)"
     >
       <div>Share webform to receive session information.</div>
       <performer-session-synopsis
         style="display: block; margin-top: 20px;"
         *ngIf="!!showSessionSynopsisSelection && !!vars.synopsis"
         [synopsisInfo]="vars.synopsis"
         [emailGenerator]="synopsisEmailGenerator.bind(this)"
         (changePerformerId)="selectPerformerForSynopsis($event)"
         (changeStatus)="setSessionItemStatus(vars.synopsis.performerId, $event, 'synopsis')"
       ></performer-session-synopsis>
       <div style="margin-top: 15px;" class="medium-hint" *ngIf="!!showSessionSynopsisSelection">
         Note: Once a submission is made the status will change from “Active” to “Submitted” and the link will be closed. To re-enable the link, change the status back to “Active”.
       </div>
     </title-toggle-wrapper>
   </ng-container>

    <title-icon [title]="'Session description'" titleIcon="description18"></title-icon>
    <input-editor *ngIf="sessionInfo.fullSession && { notProgram: readState !== readStates.Program || !event || event.is_readonly } as vars"
      [object]="sessionInfo.fullSession" 
      [prop]="'description'" 
      [disabled]="!!vars.notProgram"
      [placeholder]="vars.notProgram ? 'No description' : 'Click to add a description...'"
      (changed)="saveSession()"
    ></input-editor>

    <title-icon class="public-links" [title]="'Public links'" titleIcon="link18"></title-icon>
    <file-handler class="public-links"
      [readfilesonly]="readState !== readStates.Program || event?.is_readonly || false"
      [type]="'Public'"
      [ctaLink]="true"
      [addText]="'ADD A LINK'"
      [hideByline]="true"
      [data]="{ files: sessionInfo.fullSession?.publicLinks || [] }" 
      (dataChange)="addPublicLinks($event)" 
    ><div class="empty-text" *ngIf="!sessionInfo.fullSession?.publicLinks?.length">
      No public links in this session
    </div></file-handler>

    <ng-container *ngIf="!ready">Loading...</ng-container>
    <ng-container *ngIf="ready">
      <ng-container [ngTemplateOutlet]="performersTemplate" [ngTemplateOutletContext]="{mobile: false}"></ng-container>
      <ng-container [ngTemplateOutlet]="performersTemplate" [ngTemplateOutletContext]="{mobile: true}"></ng-container>
      <ng-container [ngTemplateOutlet]="sponsorsTemplate" [ngTemplateOutletContext]="{mobile: false}"></ng-container>
      <ng-container [ngTemplateOutlet]="sponsorsTemplate" [ngTemplateOutletContext]="{mobile: true}"></ng-container>
    </ng-container>
    

  </ng-container>

  <ng-container *ngIf="sessionInfo.fullSession !== undefined && selectedTab?.id === tabs.facilitator">
    <title-icon [titleIcon]="'DESCRIPTION18'" [title]="'Facilitator Notes'"></title-icon>
    <input-editor class="notes"
      [disabled]="readState !== readStates.Program || event?.is_readonly || false"
      [object]="sessionInfo.fullSession" 
      [prop]="'facilitatorNotes'"
      [placeholder]="readState !== readStates.Program || event?.is_readonly ? '' : 'Add notes...'"
      (changed)="saveSession()"
    ></input-editor>
  </ng-container>
  <ng-container *ngIf="selectedTab?.id === tabs.cues">
    <action-button [text]="'Open Run of Show'" (click)="editCueSheet()"></action-button>
    <!--<cue-sheet [session]="sessionInfo.fullSession" [forceReadOnly]="true" ></cue-sheet>-->
  </ng-container>
  

  <ng-container *ngIf="selectedTab?.id === tabs.notes && sessionInfo.fullSession">
    <div class="explanation">Information added here will only appear in the Performer Brief area.</div>
    <editable-notes
      [initClosed]="true"
      [noPadding]="true"
      [readOnly]="readState !== readStates.Program || event?.is_readonly || false"
      [notes]="[{ id: 'presentationNotes', title: 'Presentation notes for performer brief', items: sessionInfo.fullSession.presentationNotes, placeholder: 'No notes'}]"
      (onChanges)="saveSession()"
    ></editable-notes>
  </ng-container>

  <ng-container *ngIf="selectedTab?.id === tabs.assets">
    <assets 
      *ngIf="selectedTab?.id === tabs.assets"
      [title]="'Session Assets'"
      [assetIds]="sessionInfo.fullSession?.assetIds || []" 
      [readOnly]="readState === readStates.ReadOnly || event?.is_readonly || false"
      (idsAdded)="addAssetIds($event)"
      (idRemoved)="removeAssetId($event)"
    ></assets>
  </ng-container>

  <ng-container *ngIf="selectedTab?.id === tabs.config">
    <tip-text
      [head]="'Tip:'"
      [body]="'This is where you can configure webforms to receive information and assets from contributors and performers.'"
    ></tip-text>
    <h3 class="receive-assets-title">Session Information</h3>
    <div>Create a webform so a contributor or performer can supply session information. Once submitted the information will appear in the &lsquo;Session info&rsquo; area and the status will change to &ldquo;Submitted&rdquo;.</div>

    <hr class="big-rule " />

  
  </ng-container>

  <ng-container *ngIf="selectedTab?.id === tabs.stagingRequests && readState !== readStates.Program && readState !== readStates.Logistics">
    <div class="hint" style="font-size: 14px;">You don’t have permission to see <strong>staging requests.</strong></div>
  </ng-container>
 
  <ng-container *ngIf="selectedTab?.id === tabs.stagingRequests && (readState === readStates.Logistics || readState === readStates.Program)">

    <tip-text [type]="'important'" [head]="'Important'" [body]="'staging requests can only be seen by users with <strong>Production</strong> permissions or in a performer brief.'"></tip-text>

    <title-icon style="margin-top: 20px; display: block;" [title]="'Staging requests'" [titleIcon]="'clipboard_question18'"></title-icon>
    <div *ngIf="!stagingRequests?.length" class="empty-text">No staging requests.</div>
    <staging-requests *ngIf="!!stagingRequests?.length" [stagingRequests]="stagingRequests"></staging-requests>

    <hr class="big-rule" style="margin: 40px 0 35px;" />

    <h3 class="receive-assets-title">Receive Staging Requests</h3>
    <div>Share webform to receive staging requests.</div>
    
    <div class="hint" style="margin: 10px -5px 0 0;">Note: Once a submission is made the status will change from “Active” to “Submitted” and the link will be closed. To re-enable the link, change the status back to “Active”.</div>

    <staging-request class="anyone"
      [readOnly]="readState !== readStates.Program"
      [stagingRequestInfo]="stagingRequest[sessionInfo.id+'_']"
      [emailGenerator]="stagingEmailGenerator.bind(this)"
      [type]="'staging'"
      (changeStatus)="setSessionItemStatus('', $event, 'stagingRequest')">
    </staging-request>

    <div *ngIf="sessionInfo.performers?.length" class="performer-assets-title">Receive staging requests from performers:</div>
    <staging-request class="performer-asset-links"
      *ngFor="let performer of sessionInfo.performers"
      [readOnly]="readState !== readStates.Program"
      [emailGenerator]="stagingEmailGenerator.bind(this)"
      [stagingRequestInfo]="stagingRequest[sessionInfo.id + '_'+performer.id]" 
      [entity]="performer"
      [type]="'staging'"
      (changeStatus)="setSessionItemStatus(performer.id || '', $event, 'stagingRequest')">
    </staging-request>
  
  </ng-container>

  <ng-container *ngIf="selectedTab?.id === tabs.quickNotes">
    <chat-box [isNotes]="true" [comments]="sessionInfo.quickNotes || []" [readOnly]="readState === readStates.ReadOnly || event?.is_readonly || false" (quickNotesChanged)="saveQuickNotes($event)" ></chat-box>
  </ng-container>

  
  <logistics-session-inlay
    *ngIf="selectedTab?.id === tabs.logistics"
    [readOnly]="readState === readStates.ReadOnly || event?.is_readonly || false"
    [session]="sessionInfo.fullSession"
    (saveSession)="saveSession()"
  ></logistics-session-inlay>

  <logistics-session-inlay
    *ngIf="selectedTab?.id === tabs.catering"
    [readOnly]="readState === readStates.ReadOnly || event?.is_readonly || false"
    [type]="'catering'"
    [filesKey]="'cateringFiles'"
    [notesKey]="'cateringNotes'"
    [itemsKey]="'cateringItems'"
    [session]="sessionInfo.fullSession"
    (saveSession)="saveSession()"
  ></logistics-session-inlay>

  <ng-container *ngIf="selectedTab?.id === tabs.tagging">
    Tag people to this session so it appears in their on site schedule timeline, schedule or brief.
    <session-tag-panel *ngIf="!!sessionInfo.fullSession"
      [readOnly]="readState === readStates.ReadOnly || event?.is_readonly || false"
      [programId]="sessionInfo.programId" 
      [session]="sessionInfo.fullSession"
    ></session-tag-panel>

  </ng-container>

</manage-wrapper>

<ng-template #performersTemplate let-mobile="mobile">
  <performers [ngClass]="{ mobile: mobile, fullScreen: !mobile }"
    [showBriefStatus]="true"
    [programId]="sessionInfo?.programId || ''"
    [performerIds]="sessionInfo?.fullSession?.performerIds || []"
    [displayType]="mobile ? performerDisplayTypes.narrowPod : performerDisplayTypes.widePod"
    [readOnly]="readState !== readStates.Program || !event || event.is_readonly || false"
    [fromManageDialog]="true"
    [sessionId]="sessionInfo.id"
    [emptyText]="'No performers in this session'"
  ></performers>
</ng-template>

<ng-template #sponsorsTemplate let-mobile="mobile">
  <sponsors [ngClass]="{ mobile: mobile, fullScreen: !mobile }"
    [displayType]="mobile ? sponsorDisplayTypes.narrowPod : sponsorDisplayTypes.widePod"
    [readOnly]="readState !== readStates.Program || !event || event.is_readonly || false"
    [sessionId]="sessionInfo.id"
    [sponsorIds]="sessionInfo.fullSession?.sponsorIds || []"
    [emptyText]="'No sponsors in this session'"
  ></sponsors>
</ng-template>


